import styled from 'styled-components'
import { getTypographyIntent } from '../Typography'
import { colors } from '../_styles/colors'

export const StyledBadgeContainer = styled.div`
  display: inline-flex;
  position: relative;
`

export const StyledBadgeContent = styled.div<{
  $overlapping: boolean
  $hidden?: boolean
  $xOffset?: number
  $yOffset?: number
}>`
  position: relative;
  ${({ $overlapping, $xOffset = 0, $yOffset = 0 }) =>
    $overlapping &&
    `
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    transform: translate(
      calc(50% + ${$xOffset}px),
      calc(-50% + ${$yOffset * -1}px)
    );
  `}
  ${(props) => (props.$hidden ? 'visibility: hidden;' : '')}
  pointer-events: none;
  user-select: none;
`

export const StyledBadgeDotIndicator = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${colors.orange50};
`

const oneDigitStyles = `
  border-radius: 50%;
  padding: 2px;
  min-width: 21.5px;
  min-height: 21.5px;
`

const multiDigitStyles = `
  border-radius: 10px;
  padding: 2px 8px;
`

export const StyledBadgeCounter = styled.div<{ $oneDigit?: boolean }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${colors.white};
  background-color: ${colors.orange50};
  ${getTypographyIntent('small')}
  ${(props) => (props.$oneDigit ? oneDigitStyles : multiDigitStyles)}
`
